import React, { useContext, useMemo } from 'react'
import { Col, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
import { Question, QuestionContainer } from '../../components/Question'
import { useUpdateValue } from '../../hooks/use-capture-question'
import useStep from '../../hooks/use-step'
import { Paths } from '../../routes/paths'
import { GbsStore } from '../../store'
import { GbsStep } from '../../store/interfaces'
import { useStepData } from '../../store/selectors'

const stepKey = 'newHealth'

export const NewHealth = () => {
  const { dispatch } = useContext(GbsStore)
  const history = useHistory()
  const stepData = useStepData(stepKey)
  const defaultValue = stepData?.value || ''

  const { updateValue, isLoading } = useUpdateValue(stepKey)

  const onContinue = async (value: any) => {
    if (isLoading) return

    const wasSuccesfull = await updateValue(value, {
      new_insurance_reason: value
    })

    if (!wasSuccesfull) return

    history.push(Paths.totalAmount)
  }

  const options = [
    {
      label: 'Specific medical need',
      value: 'Specific medical need',
      text: ''
    },
    {
      label: 'Attract talent',
      value: 'Attract talent',
      text: ''
    },
    {
      label: 'I want a tax credit',
      value: 'I want a tax credit',
      text: ''
    },
    {
      label: 'Shopping around',
      value: 'Shopping around',
      text: ''
    },
    {
      label: 'We can afford it now',
      value: 'We can afford it now',
      text: ''
    },
    {
      label: 'Other',
      value: 'Other',
      text: ''
    }
  ]
  const stepConfig: Omit<GbsStep, 'data'> = useMemo(() => {
    return {
      topBar: {
        completedPercentage: 30,
        backCallback: () => history.push(Paths.planningPurchasing)
      },
      bottomBar: {
        hidden: true
      }
    }
  }, [history])

  useStep(stepKey, stepConfig, dispatch)

  return (
    <QuestionContainer>
      <Row>
        <Col xs={12}>
          <Question
            type="choice"
            text="Why are you looking for new health insurance right now?"
            options={options}
            defaultValue={defaultValue}
            onChange={onContinue}
          ></Question>
        </Col>
      </Row>
    </QuestionContainer>
  )
}

export default NewHealth
